import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vuetify/styles'; // Global CSS has to be imported;
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import axios from "axios";
import VueAxios from "vue-axios";
import VueNumerals from 'vue-numerals';
import { createHead } from '@vueuse/head'

const head = createHead()

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                anchor: '#3e7ce0',
                primary: '#3e7ce0',
            },
        },
    },
})

const app = createApp(App)

app.use(router)
app.use(head)
app.use(vuetify)
app.use(VueAxios, axios)
app.use(VueNumerals)

const apiBase = process.env.VUE_APP_API_URL || 'https://ims-api.handleglobal.com'
const frontendUrl = process.env.VUE_APP_FRONTEND_URL || 'https://marketplace.handleglobal.com'

axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

app.config.globalProperties.$main_api = apiBase.replace(/\/$/, '') + '/api'
app.config.globalProperties.$csrf_url = apiBase.replace(/\/$/, '') + '/sanctum/csrf-cookie'
app.config.globalProperties.$application_link = frontendUrl.replace(/\/$/, '')

//colors
//global constants
//spinner color
app.config.globalProperties.$spinner_color = '#BFDBFE';

//primary and title color
app.config.globalProperties.$primary_color = '#3e7ce0';
app.config.globalProperties.$primary_title_color = '#ffffff';

//notes colors
app.config.globalProperties.$my_notes_color = '#6D72D1';
app.config.globalProperties.$other_notes_color = '#A45899';

//order prefix
app.config.globalProperties.$order_barcode_prefix = 'O-';

//notification color and icons
app.config.globalProperties.$alert_danger_color = 'red-lighten-5';
app.config.globalProperties.$alert_success_color = 'green-lighten-5';
app.config.globalProperties.$alert_danger_icon = 'mdi-alert-circle-outline';
app.config.globalProperties.$alert_success_icon = 'mdi-check-circle';

app.config.globalProperties.$confirmation_icon = 'mdi-help-circle-outline';


//drawer widths
app.config.globalProperties.$fullWidth = window.innerWidth * .90;
app.config.globalProperties.$halfWidth = window.innerWidth * .50;
app.config.globalProperties.$quarterWidth = window.innerWidth * .25;

//heights
app.config.globalProperties.$fullHeight = window.innerHeight * .90;
app.config.globalProperties.$halfHeight = window.innerHeight * .50;
app.config.globalProperties.$quarterHeight = window.innerHeight * .25;

//icons
app.config.globalProperties.$cart_icon = 'mdi-cart-outline';
app.config.globalProperties.$email_icon = 'mdi-email';
app.config.globalProperties.$phone_icon = 'mdi-phone';
app.config.globalProperties.$account_icon =  'mdi-account';
app.config.globalProperties.$signup_icon = 'mdi-account-plus';
app.config.globalProperties.$passwords_icon = 'mdi-lock-outline';
app.config.globalProperties.$tools_icon = 'mdi-tools';
app.config.globalProperties.$form_icon = 'mdi-text-box-edit-outline';
app.config.globalProperties.$equipment_icon = 'mdi-wheelchair';
app.config.globalProperties.$truck_icon = 'mdi-truck-fast-outline';
app.config.globalProperties.$delete_icon = 'mdi-delete-outline';
app.config.globalProperties.$down_icon = 'mdi-menu-down';
app.config.globalProperties.$menu_icon = 'mdi-dots-vertical';
app.config.globalProperties.$close_icon = 'mdi-close-box';
app.config.globalProperties.$products_icon = 'mdi-package-variant-closed';
app.config.globalProperties.$view_icon = 'mdi-eye-circle-outline';
app.config.globalProperties.$calendars_icon = 'mdi-calendar-range';
app.config.globalProperties.$buildouts_icon = 'mdi-hammer';
app.config.globalProperties.$circlecheck_icon = 'mdi-checkbox-marked-circle-outline';
app.config.globalProperties.$search_icon = 'mdi-magnify';
app.config.globalProperties.$map_icon = 'mdi-map-marker-outline';
app.config.globalProperties.$sort_icon = 'mdi-sort';
app.config.globalProperties.$stepper_icon = 'mdi-step-forward';


app.mount('#app');